import React from 'react';
import { shallow } from 'enzyme';
import axios from 'axios';
import Cookies from 'js-cookie';
import ToastStore from '../../../stores/ToastStore';
import CurrentUserStore from '../../../stores/CurrentUserStore';
import GuideButton from '../GuideButton';

jest.mock('axios');
jest.mock('js-cookie', () => ({
  get: jest.fn(),
}));
jest.mock('../../../stores/ToastStore', () => ({
  __esModule: true,
  default: {
    showToast: jest.fn(),
  },
}));

jest.mock('../../../stores/CurrentUserStore', () => ({
  __esModule: true,
  default: {
    currentUser: {
      email: '',
    },
  },
}));

describe('GuideButton', () => {
  const originalOpen = window.open;

  beforeEach(() => {
    window.open = jest.fn();
    Cookies.get.mockReturnValue('https://example.com/api');
    ToastStore.showToast.mockClear();
    axios.post.mockReset();
  });

  afterAll(() => {
    window.open = originalOpen;
  });

  it('opens the returned TM login url when the API succeeds', async () => {
    axios.post.mockResolvedValue({
      data: { status: true, url: 'https://training.example.com/login' },
    });

    const wrapper = shallow(<GuideButton action="schedules" />);
    await wrapper.instance().handleProProfsLogin({
      preventDefault: jest.fn(),
    });

    expect(axios.post).toHaveBeenCalledWith(
      'https://example.com/api/tm_integrations/login_to_tm',
      null,
      { params: { email: '' } }
    );
    expect(window.open).toHaveBeenCalledWith(
      'https://training.example.com/login',
      '_blank',
      'noopener,noreferrer'
    );
    expect(ToastStore.showToast).not.toHaveBeenCalled();
  });

  it('shows a toast and does not redirect when the API returns a failure', async () => {
    axios.post.mockResolvedValue({
      data: { status: false, message: 'Failed to login to TM' },
    });

    const wrapper = shallow(<GuideButton action="schedules" />);
    await wrapper.instance().handleProProfsLogin({
      preventDefault: jest.fn(),
    });

    expect(ToastStore.showToast).toHaveBeenCalledWith(
      'Failed to login to TM',
      'danger'
    );
    expect(window.open).not.toHaveBeenCalled();
  });
});
